import CardItemProps from "./CardItemProp";
import Component from "vue-class-component";
import { busHome } from "@/views/Home/HomeBus";

@Component({
  name: "CardItem",
})
export default class CardItem extends CardItemProps {
  searchServiceDefaultName(): void {
    busHome.$emit("searchServiceDefaultNameByCode", this.code);
  }
}
